import gql from "graphql-tag";

export default gql`
    mutation ($discountId: ID!) {
        deleteDiscount (discountId: $discountId) {
            success
        }
    }
`;
